import { render } from "./Phone.vue?vue&type=template&id=46a8ee50"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Phone.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46a8ee50"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46a8ee50', __exports__)) {
    api.reload('46a8ee50', __exports__)
  }
  
  module.hot.accept("./Phone.vue?vue&type=template&id=46a8ee50", () => {
    api.rerender('46a8ee50', render)
  })

}


export default __exports__